import React from "react";
import { PlusCircle as PlusCircleIcon, Copy as CopyIcon } from "react-feather";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import SvgIcon from "@mui/material/SvgIcon";
import Grid from "@mui/material/Grid";
import useMediaQuery from "@mui/material/useMediaQuery";

import { ProjectActionsProvider, useProjectActions } from "../../../contexts/projectActions";
import { usePermissions } from "../../../contexts/permissions";
import useAuth from "../../../hooks/useAuth";

export const ProjectActions = () => {
  const { user } = useAuth();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("sm"));
  const {
    handleToggleClient,
    handleToggleProject,
    handleToggleDuplicateProject,
  } = useProjectActions();
  const { can } = usePermissions();
  const { settings } = user.company;
  const showClientButton =
    can("projects.write") && can("clients.write") && !settings.receiving_wizard;
  const showDuplicateButton = can("projects.write") && settings.receiving_wizard;

  return (
    <Box
      style={{ width: "100%" }}
      display="flex"
      justifyContent={isMobile ? undefined : "space-between"}
    >
      <Grid container spacing={1} sx={{ width: "100%" }}>
        {showDuplicateButton && (
          <Grid size={{ xs: 12, sm: 6 }}>
            <Button
              fullWidth
              color="primary"
              variant="outlined"
              onClick={handleToggleDuplicateProject}
              style={{ height: "45px" }}
              startIcon={
                <SvgIcon fontSize="medium">
                  <CopyIcon />
                </SvgIcon>
              }
            >
              Duplicate {settings.filter_field2}
            </Button>
          </Grid>
        )}
        <Grid size={{ xs: 12, sm: showDuplicateButton ? 6 : 12 }}>
          <Grid container spacing={1}>
            {showClientButton && (
              <Grid size={6}>
                <Button
                  fullWidth
                  id="addClientAndProjectModal"
                  style={{ height: "45px" }}
                  color="primary"
                  variant="outlined"
                  onClick={handleToggleClient}
                  startIcon={
                    <SvgIcon fontSize="medium">
                      <PlusCircleIcon />
                    </SvgIcon>
                  }
                >
                  {/* isMobile ? `Add Client` : `Add Client and Project`*/}
                  {isMobile
                    ? `Add ${settings.filter_field1}`
                    : `Add ${settings.filter_field1} and ${settings.filter_field2}`}
                </Button>
              </Grid>
            )}
            <Grid size={showClientButton ? 6 : 12}>
              {can("projects.write") && (
                <Button
                  fullWidth
                  id="addProjectModal"
                  color="primary"
                  variant="contained"
                  onClick={handleToggleProject}
                  style={{ height: "45px" }}
                  startIcon={
                    <SvgIcon fontSize="medium">
                      <PlusCircleIcon />
                    </SvgIcon>
                  }
                >
                  Add {settings.filter_field2}
                </Button>
              )}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default function ProjectActionsWithProvider() {
  return (
    <ProjectActionsProvider>
      <ProjectActions />
    </ProjectActionsProvider>
  );
}
